import React, { Component} from "react";
import { Container, Button, Col, Row } from 'react-bootstrap'
import Acerca from "./Acerca";

const AboutComp = () => {
  return (
    <>
    <section className="about-container">
        <Container>
            {/* <h1 className='about-title' style={{textTransform: 'uppercase'}}><strong>Acerca de</strong></h1>
            <p><br></br>Hola! este proyecto es solamente de practica para aplicar conocimientos de Frontend y Backend y no es para uso comercial. <a href="https://lnr.com.ar" target="_blank" rel="noreferrer">Sitio Personal</a>.
            <br></br>Utilizando ReactJS, Firebase, Bootstrap y consumo de api  <a href="https://dash.valorant-api.com/about" target="_blank" rel="noreferrer">Valorant-API</a>.
            <br></br>El template del proyecto es de <a href="https://github.com/ega-erinovian/valorant-agent" target="_blank" rel="noreferrer">ega-erinovian</a>.
            <br></br>
            <br></br>Riot Games, VALORANT y cualquier logotipo relacionado son marcas comerciales o marcas registradas de Riot Games, Inc.
            <br></br>Riot Games, Valorant, and all associated properties are trademarks or registered trademarks of Riot Games, Inc.
            <br></br>Sitio oficial de <a href="https://playvalorant.com/" target="_blank" rel="noreferrer">VALORANT</a>.
            <br></br>
            <br></br>
            <br></br>
            <Button class="button" className="nav-button ms-2" size="sm"  href="https://playvalorant.com/" target="_blank" rel="noreferrer">
                <strong >Valorant</strong>
              </Button>
              <Button class="button" className="nav-button ms-2" size="sm"  href="https://valorantesports.com/" target="_blank" rel="noreferrer">
                <strong >Valorant Esports</strong>
              </Button>
              <Button class="button" className="nav-button ms-2" size="sm"  href="https://valorant-api.com/" target="_blank" rel="noreferrer">
                <strong >Valorant-API</strong>
              </Button>
              <Button class="button" className="nav-button ms-2" size="sm"  href="https://lnr.com.ar" target="_blank" rel="noreferrer">
                <strong >LNR</strong>
              </Button>
            </p> */}

            <Acerca />
        </Container>    
    </section>
    </>
  )
}

export default AboutComp